import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from "react";


function Contact() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="contact" className="mb-20 pt-32">
      <div className="container">
        <div className="w-full" data-aos="fade-down" data-aos-duration="1000" data-aos-delay="400" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
          <div className="text-auto mx-auto mb-16 max-w-full text-center md:w-2/3">
            <h1 className=" mb-4 font-mukta text-2xl font-bold text-primary md:text-4xl">
              Contact
            </h1>
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              {" "}
              Let's Talk Now
            </h2>
            <p className="text-sm font-medium text-slate-500 md:text-base">
              Would you like to get in touch with me? I'd be thrilled to hear
              from you! Please use the contact information below to reach out or
              send a message. I'll do my best to respond as quickly as possible
            </p>
          </div>
        </div>
        <form data-aos="flip-up" data-aos-duration="1000" data-aos-delay="800" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
          <div className="w-full md:mx-auto md:w-2/3">
            <div className="mb-8 w-full px-4">
              <label
                htmlFor="name"
                className="text-base font-semibold text-primary "
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                placeholder="example: yanto"
                className="w-full rounded-lg bg-slate-200 p-3 text-slate-700 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
              ></input>
            </div>
            <div className="mb-8 w-full px-4">
              <label htmlFor="email">
                <span className="text-base font-semibold text-primary ">
                  Email
                </span>
                <input
                  type="email"
                  id="email"
                  placeholder="example: jamal56@gmail.com"
                  className="peer w-full rounded-lg bg-slate-200 p-3 text-slate-700 invalid:text-pink-700 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary invalid:focus:border-pink-800 invalid:focus:ring-pink-700"
                ></input>
                <p className="invisible m-1 text-sm text-pink-600 peer-invalid:visible">
                  Invalid e-mail
                </p>
              </label>
            </div>
            <div className="mb-8 w-full px-4">
              <label
                htmlFor="message"
                className="text-base font-semibold text-primary "
              >
                Message
              </label>
              <textarea
                type="textarea"
                id="message"
                className="w-full rounded-lg bg-slate-200 p-3 text-slate-700 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
              ></textarea>
            </div>
            <div className="w-full px-4">
              <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Contact;
